import { colors } from '../../colors';
var promoBanner = {
  bgColor: colors.cream,
  fontColor: colors.ash,
  textColorDark: colors.ash,
  textColorLight: colors.white
};
export default promoBanner;